export default __webpack_public_path__ + "static/Captain_M_400x650px-8ea980a77458fd5740f06e7190dd4c99.png";